module.exports = __webpack_public_path__ + "media/images/icon-mybenefits2-d2724bdea9edd09ab7195dda83625814.svg";